module.exports = __webpack_public_path__ + "static/media/helene-broderick-interiors.05f34fd8.png";